import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Kardex } from 'src/app/modelos/kardex';
import { KardexService } from 'src/app/services/kardex.service';

@Component({
  selector: 'app-informacion-kardex',
  templateUrl: './informacion-kardex.component.html',
  styleUrls: ['./informacion-kardex.component.css']
})
export class InformacionKardexComponent implements OnInit {


  kardex: Kardex = new Kardex();
  contratantes:any;
  detalleMovimientoRrpp:any;

  constructor(private kardexService:KardexService,private rutaActiva: ActivatedRoute, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.cargarData();
  }

  cargarData(){
    this.spinner.show();
    this.kardexService.GetByNumKardex(this.rutaActiva.snapshot.params.id).subscribe(response => {
      this.spinner.hide();
      if(response.inCodigoRespuesta == 200){
        this.kardex.fechaIngreso = response.kardexs[0].fechaIngreso;
        this.kardex.numKardex = response.kardexs[0].numKardex;
        this.kardex.contrato = response.kardexs[0].contrato;
        this.kardex.referencia = response.kardexs[0].referencia;
        this.kardex.fechaInstrumento = response.kardexs[0].fechaInstrumento;
        this.kardex.numeroInstrumento = response.kardexs[0].numeroInstrumento;
        this.kardex.fechaConclusion = response.kardexs[0].fechaConclusion;
        this.kardex.abogadoResponsable = response.kardexs[0].abogadoResponsable;
        this.contratantes = response.contratantes;
        this.detalleMovimientoRrpp = response.detalleMovimientosRrpp;
      }


    }, error => {

    });
  }

}
